import { AnswerModeEnum, ExamModeEnum } from '~/src/constants/exam';
import { ComputedQuestionType } from './../../store/modules/exam-answer/types';
import { ExamItemOption } from '~/src/types/exam/examItem';
import { ExamItemCardModeEnum } from '~/src/constants/exam/answerFlow';

export const isSubjective = (questionType: ComputedQuestionType) => {
  return [
    ComputedQuestionType.Fill,
    ComputedQuestionType.MaterialRichText,
    ComputedQuestionType.RichText,
  ].includes(questionType);
};

export const isEqualMultipleChoice = (userAnswer: string[], rightAnswer: string[]) => {
  return (
    userAnswer.length === rightAnswer.length &&
    userAnswer.length === Array.from(new Set([...userAnswer, ...rightAnswer])).length
  );
};

export const getOptionIndex = (index: number, splitter?: string) => {
  splitter = splitter || '.';
  const indexList = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  return indexList[index] + splitter || '';
};

export const computeRadioClass = (
  mode: ExamItemCardModeEnum,
  examMode: ExamModeEnum,
  isCheck: boolean,
  option: ExamItemOption,
  answerMode: AnswerModeEnum,
  rightValue: string | string[]
) => {
  const showAnswer =
    mode === ExamItemCardModeEnum.Review ||
    (examMode === ExamModeEnum.ChapterPractice && isCheck) ||
    (examMode === ExamModeEnum.KnowledgeExam && isCheck) ||
    (mode === ExamItemCardModeEnum.Exam && answerMode === AnswerModeEnum.PracticeMode && isCheck);

  if (showAnswer || answerMode === AnswerModeEnum.RecitationMode) {
    if (typeof rightValue === 'string') {
      if (rightValue === option.value) {
        return 'is-true';
      } else {
        return 'is-false';
      }
    } else {
      if (rightValue.includes(option.value)) {
        return 'is-true';
      } else {
        return 'is-false';
      }
    }
  }
};
